import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';
import Button from '../../components/Button/Button';

const openInNewTab = url => {
    window.open(url, '_blank');
};

const SetUpBilling = () => {
    return (
        <Timeline
            heading="set up your billing"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon15"
                    name="dollar"
                    datacy="dollar"
                    size="2x"
                />
            }>
            If you and your agent haven’t already set up your first payment, get ready now.
            <br />
            <br />
            You can review your bill plan options and any payments you’ve made 30 days before your
            policy is effective. You’ll receive a bill in the mail, or simply visit us online.
            <div>
                <Button
                    heapAttribute="setup-billing-pay-button"
                    datacy="pay-bill"
                    text="Pay bill now"
                    type="secondary"
                    onClick={() =>
                        openInNewTab('https://customer.safeco.com/accountmanager/account/login')
                    }
                />
            </div>
        </Timeline>
    );
};

export default SetUpBilling;



// WEBPACK FOOTER //
// ./src/containers/SetUpBilling/SetUpBilling.jsx